<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入搜索词"></el-input>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
		  <el-input v-model="numtui" style="width: 150px;" placeholder="请输入数量"></el-input>
		  <el-button type="primary" style="background-color: #409eff;" @click="donum(2)" round>确定</el-button>
      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 70%;margin-left: 0;height: 800px;text-align: center;">

            <el-table-column

              width="400"
              label="名称"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.describe}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="700"
              label="标签"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.lable}}</div>
               </template>
            </el-table-column>
          	<el-table-column

              width="250"
          	  label="图片查看\修改"
          	   >
              <template slot-scope="scope">

                <el-row v-if="scope.row.img_s == 0">

                  <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index,scope.row)">
                    查看图片

                  </el-col>
                </el-row>
                <el-row v-if="scope.row.img_s == 1">

                  <img v-if="scope.row.img_01" :src="scope.row.img_01" class="avatar">
                </el-row>
              </template>
          	</el-table-column>




            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="10"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
</el-container>
</template>
<style>
  th div{
    text-align: center;
  }
</style>
<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         seachName:'',
         numtui:50

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadList();

    },

	methods:{
    donum(t){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          t:t,
          n:this.numtui

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/numTuiSave'
      })
      .then(res=>{
        alert('保存成功')

      })
      .catch(err=>{

      });
    },
    seeImg(index,row){
      row['img_s'] = 1
      this.$set(this.list,index,row);



    },
    seach(){
      this.loadList();
    },
    onChangeStripe(){
      this.loadList()
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/goodtui'
      })
      .then(res=>{

        this.list = res.data.list;
        this.numtui = res.data.num;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
        })

        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/goodtui.vue